import React from "react";

import styles from "./PatternedImageOverlay.module.scss";

const PatternedImageOverlay = ({ backgroundImage, inView }) => (
	<div className={`bg-pattern ${inView ? styles.pattern : styles.hide}`} style={{ backgroundImage: `url(${backgroundImage})` }} />
);

export default PatternedImageOverlay;